//将字符串formatter函数用eval执行插件
export default {
  methods: {
    labelFormaterStringToFuncPlugin(opt) {
      this.$nextTick(() => {
        if (!this.$refs.radar) {
          setTimeout(opt => {
            this.labelFormaterStringToFuncPlugin(opt)
          }, 500)
        }
        let myChartWidth = this.$refs.radar.getWidth()
        opt.series[0].labelLayout = function (params) {
          const isLeft = params.labelRect.x < myChartWidth / 2
          const points = params.labelLinePoints
          // Update the end point.
          points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params.labelRect.width
          return {
            labelLinePoints: points
          }
        }
      })
    }
  }
}
